import { OrderStatus, PriceOverrideSort } from "@classes-service-types/index.ts";
import { LIBRARY_IDS, MISC_LIBRARY_ID } from "@/constants.ts";

export const PRODUCT_TYPE_OPTIONS = [
  { key: LIBRARY_IDS.classes, name: "Classes" },
  { key: LIBRARY_IDS.events, name: "Event Occurrence" },
  { key: LIBRARY_IDS.housing, name: "Housing" },
  { key: LIBRARY_IDS.internships, name: "Internship" },
  { key: MISC_LIBRARY_ID, name: "Misc Product" },
];

export const PRICE_OVERRIDE_SORT_OPTIONS_MAP = {
  [PriceOverrideSort.Id]: "Id",
  [PriceOverrideSort.Amount]: "Amount",
  [PriceOverrideSort.ProgramSession]: "Program Session",
  [PriceOverrideSort.RequestedDate]: "Requested Date",
  [PriceOverrideSort.StudentName]: "Student Name",
  [PriceOverrideSort.DecisionDate]: "Decision Date",
};

export const ORDER_STATUSES_OPTIONS = Object.keys(OrderStatus).map((key) => ({
  key: OrderStatus[key],
  name: OrderStatus[key],
}));
